import { GenderEnum, UserAccountStatusEnum } from '@/lib/enum';
import { ISearchResponse } from '@/lib/interface';
import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { IFetchDataParams } from '@/interfaces';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import dayjs from 'dayjs';

type TParams = IFetchDataParams & {
	accountStatus?: UserAccountStatusEnum[];
  emailOrUsername?: string;
  gender?: GenderEnum[];
  countryIso3?: string;
  certified?: boolean;
  createdFrom?: Date;
  createdTo?: Date;
  banned?: boolean;
  ids?: string[];
  email?: string;
  transactionId?: string;
};
type TResponseData = ISearchResponse;

export const useRequestGetUsers = (params?: TParams, run = true, url?: string) => {

  const apiUrl = url || routes.api.searchUser;
  const { invalidate } = useInvalidateQueries();
  const { isFetching, isLoading, data, error } = useQuery({
    queryKey: [apiUrl, params, run],
    queryFn: ({ queryKey: [_url, _params, _run] }) =>
      !_run
        ? Promise.resolve(null)
        : fetchQuery(_url as string, _params as TParams)
  });

  const users = (data?.data ?? []);

  const fetchQuery = (url: string, params: TParams) =>
    apiClient
      .get<TResponseData>(url, params)
      .then(handleApiResponse)
      .then(
        data =>
          data
            ? ({
              ...data,
              data: (
                data.data
                  ? [...data.data]
                    .map(
                      l => ({
                        ...l,
                        createdAt: dayjs(l.createdAt).toDate()
                      })
                    )
                  : data.data
              )
            })
            : data
      );

  const fetchData = (params: TParams) =>
    fetchQuery(apiUrl, params);

  const refresh = () =>
    invalidate(apiUrl);

  return ({
    data: data as TResponseData,
    isLoading,
    isFetching,
    fetchData,
    refresh,
    users,
    error
  });

};
